import { Route, Routes, Navigate } from 'react-router-dom';
import { useRehydrateTokens } from '@digiwedge/hooks-auth-web';
import { Login } from '@digiwedge/ui-antd';
import { CartProvider } from '@digiwedge/ui-axiz';

import { IdpProvider } from './auth/IdpProvider.js';
import ShopLayout from './layout/ShopLayout.js';
import ShopPage from './pages/ShopPage.js';
import ProductDetailPage from './pages/ProductDetailPage.js';
import CheckoutPage from './pages/CheckoutPage.js';
import OrderConfirmationPage from './pages/OrderConfirmationPage.js';
import RegisterPage from './pages/RegisterPage.js';
import OrderHistoryPage from './pages/OrderHistoryPage.js';
import UserOrderDetailPage from './pages/UserOrderDetailPage.js';

// QueryClientProvider is already provided by main.tsx - do not duplicate here

export function App() {
  useRehydrateTokens();

  return (
    <IdpProvider>
      <CartProvider>
        <Routes>
          <Route path="/" element={<ShopLayout />}>
            <Route index element={<ShopPage />} />
            <Route path="products/:brand/:productId/:market" element={<ProductDetailPage />} />
            <Route path="checkout" element={<CheckoutPage />} />
            <Route path="order-confirmation/:orderId" element={<OrderConfirmationPage />} />
            <Route path="orders" element={<OrderHistoryPage />} />
            <Route path="orders/:orderId" element={<UserOrderDetailPage />} />
          </Route>
          <Route path="/register" element={<RegisterPage />} />
          <Route
            path="/login"
            element={
              <Login
                appName="YOLO Shop"
                backgroundImageUrl="https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?q=80&w=2070&auto=format&fit=crop"
                defaultRemember={true}
                overlay="gradient"
              />
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </CartProvider>
    </IdpProvider>
  );
}

export default App;
